<template>
    <layout>
        <div class="container-fluid">
           <div class="row no-gutters">
                <div class="col-sm-12">
                    <form autocomplete="off" method="post" data-vv-scope="form" @keyup.enter="saveItem" @submit.prevent="saveItem">
                        <div class="row mb-3">
                            <div class="col-sm-auto">
                                <h1 class="content-title">{{ titleItem }}</h1>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-8">
                                <div class="form-group">
                                    <MaterialInput
                                        :readonly="readonlyFormItem"
                                        type="text" class="city-form-group city-bg"
                                        id="input-name"
                                        name="name"
                                        v-model.trim="form.name"
                                        v-validate="'required|min:3'"
                                        :inputClasses="[{'is-invalid': fnHasError('name') }]"
                                        :error=" fnFirstError('name')">
                                        Nome
                                    </MaterialInput>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <MaterialSelect
                                        :disabled="readonlyFormItem"
                                        class="city-form-group city-bg"
                                        id="input-first_role"
                                        name="first_role"
                                        label="name"
                                        :filterable="true"
                                        :options="lists.onoff"
                                        v-model.trim="form.first_role"
                                        :reduce="option => option.code"
                                        v-validate="'required'"
                                        :inputClasses="[{'is-invalid': fnHasError('first_role') }]"
                                        :error=" fnFirstError('first_role')"
                                        helpText="Deseja atribuir esta role quando um utilizador é registado?">
                                        1º Perfil
                                    </MaterialSelect>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 acls-list">
                                <div class="form-group">
                                    <h5 class="mb-2">Permissões</h5>
                                    <div id="jstree">
                                        <role-tree-acl field="acl_private" ref="treeAcls" :items="lists.acls"></role-tree-acl>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <buttons-footer
                            :enableButtons="!readonlyFormItem"
                            :cancelTitle="cancelTitle"
                            :submitTitle="submitTitle"
                            :isDisabled="isDisabled"
                            @save="onBeforeSaveItem"
                            @cancel="handleBack(`${moduleCode}.${pageID}`, true)"
                        >
                        </buttons-footer>
                    </form>
                </div>
            </div>
        </div>
    </layout>
</template>

<script>
    import GeneralMixin     from './../../mixin';
    import RoleTreeAcl from './../../elements/RoleTreeAcl';

    export default {
        mixins: [
            GeneralMixin,
        ],
        components: {
            RoleTreeAcl
        },
        data() {
            return {
                pageID: 'roles',
                autoloadItem: false,
                lists: {
                    loaded: false,
                    onoff: [{'id': 1, 'name': 'Sim', 'code': true}, {'id': 2, 'name': 'Não', 'code': false}],
                    acls: []
                },
                form: {
                    id: null,
                    name: null,
                    first_role: false,
                    permissions: [],
                    acl_ids: [],
                },
            }
        },
        computed: {
            isDisabled() {
                //tenho de forçar, caso contrario não ativa quando se muda apenas as permissões...
                return false;
            },
        },
        mounted() {
            this.loadLists().then(res => {
                if(res) {
                    if(this.form.id){
                        this.loadItem().then( res => {
                            if(res){
                                this.initRoleTreeAcl();
                            }
                        });
                    }else{
                        this.initRoleTreeAcl();
                    }
                }
            });
        },
        methods: {
            async loadLists() {
                if (!this.lists.loaded) {
                    return await this.$http.get(this.url.getAcls)
                    .then(res => {
                        this.lists.acls = res.data.data;
                        this.lists.loaded = true;
                        return true;
                    })
                    .catch(error => {
                        this.lists.loaded = false;
                        this.showHttpError(error);
                        return false;
                    });
                }
            },
            initRoleTreeAcl() {
                this.$nextTick(() => {
                    $(()=> {
                        let plugins = [];
                        if(!this.readonlyFormItem){
                            plugins.push('checkbox');
                        }
                        $('#jstree').jstree({
                            core:{
                                expand_selected_onload: false,
                            },
                            "plugins" : plugins
                        });
                        $('#jstree').on("changed.jstree", (e, data) => {
                            this.form.acl_ids = data.selected
                        });
                        this.form.permissions.map(item => {
                            $('#jstree').jstree('check_node', item.id);
                        });
                        $('#jstree').jstree('close_all');

                    });
                });
            },
            onBeforeSaveItem() {
                delete this.form.permissions;
                this.saveItem();
            },
        }
    }
</script>

<style lang="scss">
    .jstree-default .jstree-clicked {
        background: transparent !important;
        border-radius: 0px !important;
        box-shadow: none !important;
    }
</style>

<style scoped lang="scss">
    .photo {
        display: flex;
        align-items: center;
        justify-content: center;

        .img-photo{
            max-width:250px;
        }
    }

    .file-photo{
        display:none;
    }
</style>
